import {User} from '.'

export const getShortName = (user: User) => {
  if (!user) return '...'
  return `${user.firstName} ${user.lastName?.slice(0, 1)}.`
}
